'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _shared = require('./shared/');

var _shared2 = _interopRequireDefault(_shared);

var _app = require('./app.config');

var _app2 = _interopRequireDefault(_app);

var _app3 = require('./app.component');

var _app4 = _interopRequireDefault(_app3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('webPublicClient.app', ['rc', _angularUiRouter2.default, _shared2.default.name]).config(_app2.default).component('app', _app4.default);


// WEBPACK FOOTER //
// ./src/app/index.js